/*******************************************************************************
  SelectSiteSimple.js

  Author: Advait; Mark Duckworth;

*******************************************************************************/

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSites, setSiteId } from "../store/siteSlice";
import { getSites } from "../apihelpers/graphqlhelpers";
import "../index.css";

/**
 * This component allows the user to select a site from the list of sites
 * owned by the tenant. If there is only one site, it selects that site
 * automatically.
 */
function SelectSiteSimple() {
  const dispatch = useDispatch();
  const isSysAdmin = useSelector((state) => state.user.sysAdmin);
  const selectedTenantId = useSelector((state) => state.selectedSite.tenantId);
  const siteList = useSelector((state) => state.selectedSite.sites);
  const selectedSiteId = useSelector((state) => state.selectedSite.siteId);
  useEffect(() => {
    async function refreshFromDB() {
      let sites = await getSites(selectedTenantId, isSysAdmin, false);
      dispatch(setSites(sites));
      if (sites.length === 1) {
        dispatch(setSiteId(sites[0].id));
      }
    }

    //TODO fetch from DB only if we don't already have all the site info
    //TODO for the selected tenant?
    if (selectedTenantId) refreshFromDB();
  }, [dispatch, isSysAdmin, selectedTenantId]);

  function handleSelectedSite(event) {
    const siteid = event.target.value;
    dispatch(setSiteId(siteid));
  }

  //***************************************************************************
  // render the UI
  //***************************************************************************
  if (siteList.length === 1) {
    return (
      <div>
        <div className="individualContainer">
          <table className="individualContainerTable">
            <tbody>
              <tr>
                <td
                  className="individualContainerTitleColumn"
                  valign="top"
                  style={{ paddingLeft: "15px" }}
                >
                  <h4 className="individualContainerTitleHeading">
                    Site: {siteList[0].siteName}
                  </h4>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  } else if (siteList.length === 0) {
    return (
      <div className="individualContainer">
        <table className="individualContainerTable">
          <tbody>
            <tr>
              <td colSpan="2" valign="top" style={{ paddingLeft: "15px" }}>
                <h4>No site available</h4>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  } else {
    const allsites = [].concat(siteList).map((site, i) => {
      return (
        <option key={i} value={site.id}>
          {site.siteName}
        </option>
      );
    });
    return (
      <div>
        <div className="individualContainer">
          <table className="individualContainerTable">
            <tbody>
              <tr>
                <td className="individualContainerTitleColumn" valign="top">
                  <h4 className="individualContainerTitleHeading">Site Selection</h4>
                </td>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td className="individualContainerSubTitleColumn">
                          <h6>Select Site to Manage</h6>
                        </td>
                        <td>
                          <select
                            className="inputFieldSelect"
                            value={selectedSiteId}
                            onChange={handleSelectedSite}
                          >
                            <option value="">-- Please Choose a Site --</option>
                            {allsites}
                          </select>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
export default SelectSiteSimple;
